import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { LabraAuthProvider } from './Tracker'
import { useTracker } from './hook'

/** Auth entry points mapped to Segment `labra_auth_provider`. */
export type TrackerAuthorizationSource = 'auth0' | 'url-jwt' | 'canvas'

type TrackerAuthRootState = {
  authorization?: {
    source?: TrackerAuthorizationSource | null
  }
}

const labraAuthProviderMap: Record<
  TrackerAuthorizationSource,
  LabraAuthProvider
> = {
  auth0: LabraAuthProvider.Labra,
  'url-jwt': LabraAuthProvider.Hubspot,
  canvas: LabraAuthProvider.Salesforce,
}

const selectAuthSource = (
  state: TrackerAuthRootState
): TrackerAuthorizationSource | null => state.authorization?.source ?? null

export const TrackerLabraAuthProviderBinding = () => {
  const tracker = useTracker()
  const authSource = useSelector(selectAuthSource)

  useEffect(() => {
    if (!tracker) {
      return
    }

    const mappedLabraAuthProvider =
      authSource && authSource in labraAuthProviderMap
        ? labraAuthProviderMap[authSource]
        : undefined

    tracker.setLabraAuthProvider(mappedLabraAuthProvider)

    if (mappedLabraAuthProvider) {
      tracker.page()
    }
  }, [tracker, authSource])

  return null
}
